


















  import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

  @Component
  export default class OneCartModalImport extends Vue {
    file: any = null

    @Prop({
      type: Boolean,
      required: true,
    })
    value!: boolean;

    @Prop({
      type: Boolean,
      required: false,
      default: false,
    })
    progress!: boolean;

    get isValid() {
      return this.file
    }

    @Watch('value')
    onVisibilityChange() {
      this.file = null
    }

    onSave() {
      const formData = new FormData()
      formData.append('file', this.file)
      this.$emit('create', formData)
    }
  }
